import { Folder } from '../api/services/dietbase/types.ts'

export const filterFolders = (
  folders: Folder[],
  mealNumber: number | string | null,
  energy: number | string | null
) => {
  return folders.filter((folder) => {
    if (mealNumber !== 'wszystkie opcje' && energy !== 'wszystkie opcje') {
      return folder.number_of_meals === mealNumber && folder.kcal === energy
    } else if (
      mealNumber === 'wszystkie opcje' &&
      energy !== 'wszystkie opcje'
    ) {
      return folder.kcal === energy
    } else if (
      energy === 'wszystkie opcje' &&
      mealNumber !== 'wszystkie opcje'
    ) {
      return folder.number_of_meals === mealNumber
    } else {
      return folder
    }
  })
}

export const removeDuplicatesForCalories = (item: (string | number)[]): (string | number)[] => {
  return [...new Set(item)]
}
